import moment from "moment";
export const Dashboardtoday = moment(new Date());
export const LastMonth = moment().subtract(1, 'months');
export const LastSixMonth =  moment().subtract(6, 'months')
export const dateFilterOptions = [
  {
    id: "last_month",
    label: "Last Month",
    value: moment().subtract(1, "months"),
  },
  {
    id: "last_3_months",
    label: "Last 3 Months",
    value: moment().subtract(3, "months"),
  },
  {
    id: "last_6_months",
    label: "Last 6 Months",
    value: moment().subtract(6, "months"),
  },
  {
    id: "current_year",
    label: "Current Year",
    value: moment().startOf("year"),
  },
  {
    id: "last_year",
    label: "Last Year",
    value: moment().subtract(1, "year").startOf("year"),
  },
  {
    id: "custom",
    label: "Custom",
    value: "custom",
  },
];
